import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import { ArrowBack } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import Heading from 'app/components/shared/Heading';
import './BrowseSearchPage.scss';

const BackToLink = ({ href, isExternalLink, label, screenReaderLabel }) => {
  return isExternalLink ? (
    <a className="back-to-link" data-key="back-to-browse" href={href}>
      <ArrowBack />
      <span aria-hidden>{label}</span>
      <ScreenReaderMessage>{screenReaderLabel}</ScreenReaderMessage>
    </a>
  ) : (
    <Link className="back-to-link" dataKey="back-to-browse" to={href}>
      <ArrowBack />
      <span aria-hidden>{label}</span>
      <ScreenReaderMessage>{screenReaderLabel}</ScreenReaderMessage>
    </Link>
  );
};

BackToLink.propTypes = {
  href: PropTypes.string.isRequired,
  isExternalLink: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  screenReaderLabel: PropTypes.string.isRequired
};

const BrowseSearchPage = ({ backToLinkProps, children, heading }) => {
  return (
    <article className="cp-browse-search-page">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <header>
              {backToLinkProps && <BackToLink {...backToLinkProps} />}
              <Heading className="heading-primary" size="large" tagName="h1" variant>
                {heading}
              </Heading>
            </header>
          </div>
        </div>
        {children}
      </div>
    </article>
  );
};

BrowseSearchPage.propTypes = {
  backToLinkProps: PropTypes.exact({
    href: PropTypes.string.isRequired,
    isExternalLink: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    screenReaderLabel: PropTypes.string.isRequired
  }),
  children: childrenShape.isRequired,
  heading: PropTypes.string.isRequired
};

export default BrowseSearchPage;
